import Page from "components/Page";
import NCRCategoryList from "./NCRCategoryList";

export default () => (
  <Page>
    <NCRCategoryList />
  </Page>
);
